/* FONTS & STYLES */
import 'roboto-fontface/css/roboto/roboto-fontface.css'
import '@mdi/font/css/materialdesignicons.css'

import './styles/main.scss'

import bootSimpL from '@simpl/core'

bootSimpL().then(_ => {})
